// Side-effect imports
import 'bootstrap'

// Library imports
import { Turbo } from '@hotwired/turbo-rails'
import ReactRailsUJS from 'react_ujs'
import reactTurboEvents from '../helpers/react_rails_ujs_turbo_events_shim'
import Rails from '@rails/ujs'

// Stimulus imports and initialization
import { Application as Stimulus } from '@hotwired/stimulus'
import Reveal from 'stimulus-reveal-controller'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

// Stylesheets
import '../src/volunteer.scss'

// Rails UJS
Rails.start()

// Turbo
Turbo.session.drive = true

// Stimulus
const stimulusApp = Stimulus.start()
stimulusApp.register('reveal', Reveal)

const volunteerControllersContext = require.context('controllers/volunteer', true, /\.js$/)
stimulusApp.load(definitionsFromContext(volunteerControllersContext))

const sharedInputsContext = require.context('controllers/shared/inputs', true, /\.js$/)
stimulusApp.load(definitionsFromContext(sharedInputsContext))

const sharedContext = require.context('controllers/shared', true, /\.js$/)
stimulusApp.load(definitionsFromContext(sharedContext))

window.stimulusApp = stimulusApp

// React
ReactRailsUJS.useContext(require.context('components', true))
reactTurboEvents.setup(ReactRailsUJS)
